const set_logged_user = 'setLoggedUser';
const set_user_permission = 'setUserPermission';

export { set_logged_user, set_user_permission };
